import styled from 'styled-components';



export const Linha = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  border-bottom: 1px solid #ddd;
`;


export const CelulaDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;


export const CelulaP = styled.p`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;
`;
